import createRouter from "./createRouter";
import TaskContainer from "@/views/Task/TaskContainer.vue";

export const routes = [
  {
    path: '/task',
    component: TaskContainer,
    redirect: '/task/todo-task-list',
    children: [
      {
        path: 'todo-task-list',
        name: 'TodoTaskList',
        component: () => import('@/views/Task/TodoTaskList.vue'),
        meta: {
          title: '我的待办',
          keepAlive: true
        }
      },
      {
        path: 'todo-read-list',
        name: 'TodoReadList',
        component: () => import('@/views/Task/TodoReadList.vue'),
        meta: {
          title: '我的待阅',
          keepAlive: true
        }
      },
      {
        path: 'draft-task-list',
        name: 'DraftTaskList',
        component: () => import('@/views/Task/DraftTaskList.vue'),
        meta: {
          title: '我的草稿',
          keepAlive: true
        }
      },
      {
        path: 'done-task-list',
        name: 'DoneTaskList',
        component: () => import('@/views/Task/DoneTaskList.vue'),
        meta: {
          title: '我的已办',
          keepAlive: true
        }
      },
      {
        path: 'history-read-list',
        name: 'HistoryReadList',
        component: () => import('@/views/Task/HistoryReadList.vue'),
        meta: {
          title: '我的已阅',
          keepAlive: true
        }
      },
      {
        path: 'create-task-list',
        name: 'CreateTaskList',
        component: () => import('@/views/Task/CreateTaskList.vue'),
        meta: {
          title: '我创建的',
          keepAlive: true
        }
      },
      {
        path: 'all-task-list',
        name: 'allTaskList',
        component: () => import('@/views/Task/AllTaskList.vue'),
        meta: {
          title: '所有流程',
          keepAlive: true
        }
      }
    ]
  }
]

export default createRouter(routes);